<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加机器人交易对配置</el-button
    >

    <el-dialog
      title="添加机器人交易对配置"
      width="800px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
    <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="260px"
        class="demo-ruleForm"
      >
        <el-form-item label="交易对" prop="symbolList">
          <el-select v-model="ruleForm.symbolList" multiple filterable  placeholder="请选择机器人交易对">
            <el-option
              v-for="item in pairData"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="robotId" prop="robotId">
          <el-input
          style="width: 225px;"
            placeholder="请输入内容"
            v-model="ruleForm.robotId"
            clearable>
          </el-input>
        </el-form-item>
    </el-form>
      <!-- <div
        style="
          display: flex;
          width: 100%;
          height: 90vh;
          justify-content: space-around;
        "
      >
        <div>
          <h3>Info</h3>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="160px"
            class="demo-ruleForm"
          >
            <el-form-item label="huoPair" prop="huoPair">
              <el-input
                v-model.trim="ruleForm.huoPair"
                placeholder="请输入huoPair"
              ></el-input>
            </el-form-item>
            <el-form-item label="fbsPair" prop="fbsPair">
            
              <el-select v-model="ruleForm.fbsPair" placeholder="请选择">
                <el-option
                  v-for="item in pairsData"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="mirrorConfig" prop="mirrorConfig">
              <el-input
                v-model.trim="ruleForm.mirrorConfig"
                placeholder="请输入mirrorConfig"
              ></el-input>
            </el-form-item>
            <el-form-item label="bargainConfig" prop="bargainConfig">
              <el-input
                v-model.trim="ruleForm.bargainConfig"
                placeholder="请输入bargainConfig"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="bargainMirrorConfig"
              prop="bargainMirrorConfig"
            >
              <el-input
                v-model.trim="ruleForm.bargainMirrorConfig"
                placeholder="请输入bargainMirrorConfig"
              ></el-input>
            </el-form-item>
            <el-form-item label="userId" prop="userId">
              <el-input
                v-model.trim="ruleForm.userId"
                placeholder="请输入userId"
              ></el-input>
            </el-form-item>
            <el-form-item label="secretKey" prop="secretKey">
              <el-input
                v-model.trim="ruleForm.secretKey"
                placeholder="请输入secretKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="accessKey" prop="accessKey">
              <el-input
                v-model.trim="ruleForm.accessKey"
                placeholder="请输入accessKey"
              ></el-input>
            </el-form-item>

            <el-form-item label-width="120px">
              <el-button type="primary" @click="submitForm('ruleForm')"
                >确定添加</el-button
              >
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="height: 100%; border-left: 1px solid gray"></div>
        <div>
          <h3>Instance</h3>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="userId" prop="userId">
              <el-input
                v-model.trim="instanceForm.userId"
                placeholder="请输入instance的userId"
              ></el-input>
            </el-form-item>
            <el-form-item label="scretKey" prop="scretKey">
              <el-input
                v-model.trim="instanceForm.scretKey"
                placeholder="请输入instance的scretKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="accessKey" prop="accessKey">
              <el-input
                v-model.trim="instanceForm.accessKey"
                placeholder="请输入instance的accessKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="online" prop="online">
              <el-input
                v-model.trim="instanceForm.online"
                placeholder="请输入instance的状态（0或1）"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div> -->

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="add">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import http from ''

export default {
  data() {
    return {
      dialogVisible: false,
      value1:[],
      id:'',
      ruleForm: {
        robotId: '',
          symbolList:[]
      
      },
      instanceForm: {
        userId: "200",
        scretKey:
          "NhqPtmdSJYdKjVHjA7PZj4Mge3R5YNiP1e3UZjInClVN65XAbvqqM6A7H5fATj0j",
        accessKey:
          "vmPUZE6mv9SD5VNHk4HlWFsOr6aKE2zvsw0MuIgwCIPy6utIco14y7Ju91duEh8A",
        online: 0,
      },
      online: 0,
      arr: [],
      result: false,
      rules: {
        id: [{ required: true, message: "请输入id", trigger: "blur" }],
      
      },
      pairsData: [],
      robotInstance: {
        userId: 215,
        scretKey:
          "NhqPtmdSJYdKjVHjA7PZj4Mge3R5YNiP1e3UZjInClVN65XAbvqqM6A7H5fATj0j",
        accessKey:
          "vmPUZE6mv9SD5VNHk4HlWFsOr6aKE2zvsw0MuIgwCIPy6utIco14y7Ju91duEh8A",
        online: 0,
      },
    };
  },
  async mounted() {
    const re = await this.getPairsData();
    this.pairsData = re.data;
  },
  computed: {
    ...mapState("RobotPairConfig", ["user",'pairData']),
  },
  methods: {
    ...mapActions("RobotPairConfig", ["createOne", "getPairsData", "getList",'addOne']),
    handleSave() {
      this.dialogVisible = false;
      this.$message.success("已添加");
    },
    closeDialog() {},
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    add() {
      this.submitForm()
      
     
    },
    async submitForm() {
      const res=await this.addOne({...this.ruleForm,robotId:Number(this.ruleForm.robotId)})
      if(res.code==0){
        this.getList({ robotId: "", page: 1, size: 10 })
        this.dialogVisible=false
        this.ruleForm= {
        robotId: '',
          symbolList:[]
      
      }
      }
      
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
